module.exports = __webpack_public_path__ + "assets/images/4d77f2aebdf63c29d025040eacd82480.png";